// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-12a89431]{display:none}.megamenu[data-v-12a89431]{position:absolute;z-index:5;left:0;width:100%;height:calc(100vh - 48px);top:48px;padding:15px 0;background:#f0f0f0;overflow-y:auto;border-top:1px solid #dadada}.megamenu-container[data-v-12a89431]{max-width:1300px;width:100%;height:100%;margin:0 auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
